import { EMBED_TO, IMAGE_URL } from "./constants";

export const resizeImage = (imageUrl, width = "original") =>
  `${IMAGE_URL}/${width}${imageUrl}`;

export const embedMovie = (id) => `${EMBED_TO}/movie?id=${id}`;

export const embedTV = (id, season, episode) =>
  `${EMBED_TO}/tv?id=${id}&s=${season}&e=${episode}`;

export const reformatDate = (date) => {
  return date?.split("-").reverse().join("-");
};

export const getTodaysDate = () => {
  const today = new Date();
  const yyyy = today.getFullYear();
  let mm = today.getMonth() + 1;
  let dd = today.getDate();

  if (dd < 10) dd = "0" + dd;
  if (mm < 10) mm = "0" + mm;

  const todaysDate = yyyy + "-" + mm + "-" + dd;
  return todaysDate;
};

export const calculateTimePassed = (time) => {
  const unit = {
    year: 12 * 30 * 7 * 24 * 60 * 60 * 1000,
    month: 30 * 7 * 24 * 60 * 60 * 1000,
    week: 7 * 24 * 60 * 60 * 1000,
    day: 24 * 60 * 60 * 1000,
    hour: 60 * 60 * 1000,
    minute: 60 * 1000,
  };

  const diff = Date.now() - time;
  for (const key in unit) {
    if (diff > unit) {
      const timePassed = Math.floor(diff / unit);
      return `${timePassed} ${key}${timePassed > 1 ? "s" : ""}`;
    }
  }

  return "Just now";
};

export const convertErrorCodeToMessage = (errorCode) => {
  if (errorCode === "auth/email-already-in-use")
    return "Your email is already in use.";
  else if (errorCode === "auth/user-not-found")
    return "Your email may be incorrect.";
  else if (errorCode === "auth/wrong-password")
    return "Your password is incorrect.";
  else return "Something went wrong. Try again.";
};
